import { LoggerContext } from '@ph-core/enums/logger-context.enum';
import { LoggerService } from '@ph-core/services/logger/logger.service';

const SLO_LOG_PREFIX = '[Phoenix SLO]';

export function logSloInfo(logger: LoggerService, message: string, detail?: Record<string, unknown>): void {
  logger.log(LoggerContext.Auth, `${SLO_LOG_PREFIX} ${message}`, detail ?? {});
}

export function logSloWarn(logger: LoggerService, message: string, detail?: Record<string, unknown>): void {
  logger.warn(LoggerContext.Auth, `${SLO_LOG_PREFIX} ${message}`, detail ?? {});
}
